module.exports = __webpack_public_path__ + "img/seta-direita.bda5ad99.svg";